interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Nombre accesible para lectores de pantalla. */
  label?: string;
}

/**
 * Interruptor tipo "on/off" reutilizable.
 * - Apagado: perilla roja con una "X".
 * - Encendido: perilla verde con un check.
 * Incluye una animación sutil de "pellizco" al cambiar de estado.
 */
export default function ToggleSwitch({
  checked,
  onChange,
  disabled = false,
  label,
}: ToggleSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      data-on={checked}
      className="toggle-switch"
    >
      <span className="toggle-switch__knob">
        <i className={checked ? "ri-check-line" : "ri-close-line"}></i>
      </span>
    </button>
  );
}